import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GlobalService } from '../../services/global.service';

@Component({
  selector: 'app-knn-regression-popup',
  templateUrl: './knn-regression-popup.component.html',
  styleUrls: ['./knn-regression-popup.component.css']
})
export class KnnRegressionPopupComponent implements OnInit {

  searchedTagName: string;
  selectedTags: string[] = [];
  tagNameList: any = [];

  constructor(public dialogRef: MatDialogRef<KnnRegressionPopupComponent>, @Inject(MAT_DIALOG_DATA) public data: any, public globalService: GlobalService) { }

  ngOnInit(): void {
    if (this.globalService.isNotNull(this.data.cleansingQualifier)) {
      this.selectedTags = this.data.cleansingQualifier.split(",");
    }
    if (this.globalService.isNotNullObject(this.data.parameterList)) {
      this.loadTagNamesList();
    }      
  }

  loadTagNamesList() {
    this.tagNameList = [...this.data.parameterList];
    if (this.globalService.isNotNullObject(this.selectedTags)) {
      for (let element of this.selectedTags) {
        let index: number = this.tagNameList.indexOf(this.tagNameList.find(a => element == a.tagName));
        this.tagNameList.splice(index, 1);
      }
    }
  }

  /**disable input box */
  disableKnnBlockQualifier() {
    let check: boolean = (this.selectedTags.length >= 5);
    return check;
  }
  
  /**
   * Allows adding multiple tags for KNN
   * @param event
   */
  onTagNameSelectedKnn(event) {
    this.selectedTags.push(event.value);
    let index: number = this.tagNameList.indexOf(this.tagNameList.find(a => event.value == a.tagName));
    this.tagNameList.splice(index, 1);
    this.searchedTagName = "";
  }

  /**
   * Removes that selected tag
   * @param index
   */
  remove(index: number): void {
    this.selectedTags.splice(index, 1);
    this.loadTagNamesList();
  }

  disableSave() {
    let check: boolean = (this.selectedTags.length < 1) || this.disableKnnBlockQualifier();
    return check;
  }

  saveDependantVariables() {
    this.dialogRef.close({ cleansingQualifier: this.selectedTags.toString() });
  }

}
